import type { ScheduleCExplanation } from '@/api/hooks/useScheduleCExplanation';
import { AmountText } from '@/components/AmountText';

export function TotalExplanationRail({ taxLine, explanation }: { taxLine: string | null; explanation: { data?: ScheduleCExplanation; isLoading: boolean; isError: boolean } }) {
  if (!taxLine) return null;
  return (
    <div className="mt-4">
      <h2 className="font-semibold">Rows behind line {taxLine}</h2>
      <p className="mt-2 text-xs text-muted-foreground">Every total drills to rows and exclusions.</p>
      {explanation.isLoading && <p role="status" className="mt-3 text-sm">Loading explanation…</p>}
      {explanation.isError && <p role="alert" className="mt-3 text-sm">This explanation is unavailable.</p>}
      {explanation.data && <div className="mt-3 space-y-2 text-sm">
        {explanation.data.rows.map((row) => <div key={row.row_ref} className="flex justify-between gap-2"><span>{row.category}</span><AmountText value={row.amount} /></div>)}
        {explanation.data.exclusions.length > 0 && <div className="border-t border-border pt-2"><p className="text-xs font-semibold text-muted-foreground">Excluded rows</p>{explanation.data.exclusions.map((row) => <div key={row.row_ref} className="mt-1 flex justify-between gap-2 text-xs"><span>{row.reason}</span><AmountText value={row.amount} /></div>)}</div>}
        {explanation.data.changes.length > 0 && <p className="text-xs text-muted-foreground">{explanation.data.changes.length} deterministic change{explanation.data.changes.length === 1 ? '' : 's'} included.</p>}
      </div>}
    </div>
  );
}

export default TotalExplanationRail;
